.media-minimal-skin .media-input-indicator {
  position: absolute;
  inset: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  justify-items: center;
  overflow: hidden;
  color: oklch(1 0 0);
  pointer-events: none;
  border-radius: inherit;
}

.media-minimal-skin {
  .media-volume-indicator,
  .media-status-indicator--state {
    position: absolute;
    inset-inline: 0;
    top: 0;
    display: flex;
    justify-content: center;
    padding-top: calc(var(--media-spacing) * 3);
    padding-bottom: calc(var(--media-spacing) * 32);
    color: inherit;
    text-shadow: 0 1px 0 var(--media-shadow-current-color);
    pointer-events: none;
    background-image: linear-gradient(
      to bottom,
      oklch(0 0 0 / 0.35),
      oklch(0 0 0 / 0.2) calc(var(--media-spacing) * 12),
      oklch(0 0 0 / 0)
    );
    transform-origin: top center;
    transition-timing-function: ease-out;
    transition-duration: 100ms;

    .media-volume-indicator__content,
    .media-status-indicator__content {
      display: flex;
      gap: calc(var(--media-spacing) * 2);
      align-items: center;
      justify-content: space-between;
      padding: calc(var(--media-spacing) * 1) calc(var(--media-spacing) * 2.5);
    }

    .media-icon {
      display: none;
      flex-shrink: 0;
      filter: drop-shadow(0 1px 0 var(--media-shadow-current-color));
    }

    .media-volume-indicator__value,
    .media-status-indicator__value {
      margin-left: auto;
    }

    @media (pointer: fine) {
      transition-property: translate, filter, opacity;
      will-change: translate, filter, opacity;
    }

    @media (pointer: coarse) {
      transition-property: translate, opacity;
      will-change: translate, opacity;
    }

    @media (pointer: fine) and (prefers-reduced-motion: no-preference) {
      transition-property: translate, filter, opacity;
    }

    @media (prefers-reduced-transparency: reduce) or (prefers-contrast: more) {
      .media-volume-indicator__content,
      .media-status-indicator__content {
        background: var(--media-controls-background-color);
        border-radius: calc(var(--media-spacing) * 2);
      }
    }

    &[data-starting-style],
    &[data-ending-style] {
      opacity: 0;
      transition-timing-function: ease-in;
      transition-duration: 400ms;

      @media (pointer: fine) and (prefers-reduced-motion: no-preference) {
        filter: blur(8px);
      }
    }

    &[data-ending-style] {
      @media (prefers-reduced-motion: no-preference) {
        translate: 0 -100%;
      }
    }
  }

  .media-seek-indicator,
  .media-status-indicator--playback {
    display: grid;
    grid-row: 1;
    grid-column: 2;
    place-content: center;
    padding: calc(var(--media-spacing) * 4);
    text-align: center;
  }
}
